/* jshint esversion: 6 */

function CachedRegExp(pattern) {

    const regExp = new RegExp(pattern, "g");

    function reset() {
        regExp.index = 0;
        regExp.lastIndex = 0;
    }

    return {
        get: () => {
            reset();
            return regExp;
        },
        test: (data) => {
            reset();
            return regExp.test(data);
        }
    };
}

export function PublisherCourseDataResponseParser() {

    const rexpResponseScoTag = new CachedRegExp("<s>(.*?)</s>"),
        rexpResponseValueTag = new CachedRegExp("<v>(.*?)</v>");

    function buildArray(response, cachedRegExp) {

        const result = response.match(cachedRegExp.get());
        let i;

        for (i = 0; i < result.length; i++) {
            result[i] = result[i].replace(cachedRegExp.get(), "$1");
        }

        return result;
    }

    return {
        getScoArray: (response) => {
            return rexpResponseScoTag.test(response) ? buildArray(response, rexpResponseScoTag) : [];
        },
        getValueArray: (response) => {
            return rexpResponseValueTag.test(response) ? buildArray(response, rexpResponseValueTag) : [];
        }
    };
}
